import { FC } from "react";
import { RouteComponentProps } from "react-router-dom";
import EnterApplication from "go-security/components/EnterApplication";

const EnterApplicationPage: FC<RouteComponentProps> = (props) => {
	return <EnterApplication />;
};
export default EnterApplicationPage;
